import { devices } from 'shared/styles/components';
import styled from 'styled-components';

export const HeaderPopupContainer = styled.div`
  display: none;
  position: relative;
  z-index: 10;

  @media ${devices.tabletMax} {
    display: flex;
  }
`;

export const HeaderPopupMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  cursor: pointer;
`;

export const HeaderPopupMenuIcon = styled.div`
  position: relative;
  width: 22px;
  height: 16px;

  span {
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.textPrimary};
    border-radius: 1px;
    transition:
      transform 0.3s ease,
      opacity 0.3s ease,
      top 0.3s ease,
      background-color 0.2s ease;
  }

  span:nth-child(1) {
    top: 0;
  }

  span:nth-child(2) {
    top: 50%;
    transform: translateY(-50%);
  }

  span:nth-child(3) {
    top: 100%;
    transform: translateY(-100%);
  }

  &.active span:nth-child(1) {
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
  }

  &.active span:nth-child(2) {
    opacity: 0;
  }

  &.active span:nth-child(3) {
    top: 50%;
    transform: translateY(-50%) rotate(-45deg);
  }

  &:hover span,
  &.active span {
    background-color: ${({ theme }) => theme.colors.textTertiary};
  }
`;

export const HeaderPopupBackdrop = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
  background: transparent;
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  visibility: ${(props) => (props.$isVisible ? 'visible' : 'hidden')};
  pointer-events: ${(props) => (props.$isVisible ? 'auto' : 'none')};
  transition: visibility 0.3s;
`;

export const HeaderPopupDropdown = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 65px;
  left: 0;
  right: 0;
  z-index: 999;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 16px;
  background: ${(props) => props.theme.colors.bgPrimaryAlpha};
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  border-radius: 0 0 12px 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  user-select: none;
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  visibility: ${(props) => (props.$isVisible ? 'visible' : 'hidden')};
  transform: ${(props) => (props.$isVisible ? 'translateY(0)' : 'translateY(-10px)')};
  transition:
    opacity 0.3s ease,
    transform 0.3s ease,
    visibility 0.3s;
  pointer-events: ${(props) => (props.$isVisible ? 'auto' : 'none')};
`;

export const HeaderPopupDropdownLink = styled.a`
  display: block;
  padding: 10px 0;
  color: ${(props) => props.theme.colors.textPrimary};
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  text-align: left;
  transition: color 0.15s;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colors.textTertiary};
  }

  &.active {
    color: ${(props) => props.theme.colors.textTertiary};
  }

  &.sign-in {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-top: 32px;
    padding: 8px 24px;
    width: 100%;
    background-color: ${(props) => props.theme.colors.bgColor};
    border-radius: 20px;
    color: ${(props) => props.theme.colors.white};
    font-weight: 600;
    transition: background-color 0.2s;

    &::before {
      content: '';
      position: absolute;
      top: -16px;
      left: 20px;
      right: 20px;
      height: 1px;
      background-color: ${(props) => props.theme.colors.border};
    }

    &:hover {
      background-color: ${(props) => props.theme.colors.bgColorAlpha};
      color: ${(props) => props.theme.colors.white};
    }
  }
`;
